const imgURL = 'https://www.tongyinpay.com/upload/'
const imgURL1 = 'https://www.ptrade.xin/upload/'
export default {
  imgURL,
  imgURL1
}


// WEBPACK FOOTER //
// ./src/request/global.js